import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'SearchFilterPipe'
})
export class SearchFilterPipe implements PipeTransform {

  transform(list: any, ...args: any[]): any {
    const filterText = args[0];
    if(!filterText){
      return list;
    }
    return list ? list.filter(item => (item.mobile && item.mobile.search(new RegExp(filterText, 'i')) > -1)
     ||
    (item.vehicleNumber && item.vehicleNumber.search(new RegExp(filterText, 'i')) > -1)
    ) : [];
  }

}
